import { useEffect, useState } from 'react';
import GsheetImg from 'assets/gsheet.png';
import { useNavigate, useParams } from 'react-router-dom';

import boltImg from 'assets/img/cms/bolt.png';
import shopifyImg from 'assets/img/cms/shopify.png';
import bubbleImg from 'assets/img/cms/bubble.png';
import htmlImg from 'assets/img/cms/html.jpg';
import landbotImg from 'assets/img/cms/landbot.jpg';
import prestaShopImg from 'assets/img/cms/prestashop.svg';
import systemIoImg from 'assets/img/cms/system.svg';
import webflowImg from 'assets/img/cms/webflow.png';
import unbouncedImg from 'assets/img/cms/unbounced.jpg';
import wordpressImg from 'assets/img/cms/wordpress.png';
import { CONFIG } from 'variables/config';
import axios from 'axios';

const IntegrateSpecificOffer = () => {
    const [loading] = useState(false);
    const [selectedService, setSelectedService] = useState(null);
    const [user, setUser] = useState(null);
    const [offer, setOffer] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const params = useParams();
    const [services] = useState([
        { name: 'Wordpress', service: 'wordpress', description: 'Vos leads automatiquement envoyes a Leadrs depuis votre cms Wordpress.', logo: wordpressImg, status: 'not-setup', source: '' },
        { name: 'Webflow', service: 'webflow', description: 'Vos leads automatiquement envoyes a Leadrs depuis votre cms Webflow.', logo: webflowImg, status: 'not-setup', source: 'https://embed.app.guidde.com/playbooks/p8M2gA5SfVzg9FMHWK69Vm' },
        { name: 'HTML', service: 'html', description: 'Vos leads automatiquement envoyes a Leadrs depuis votre propre site.', logo: htmlImg, status: 'not-setup', source: '' },
        { name: 'Shopify', service: 'shopify', description: 'Vos leads automatiquement envoyes a Leadrs depuis votre cms Shopify.', logo: shopifyImg, status: 'not-setup', source: '' },
        { name: 'Bubble', service: 'bubble', description: 'Vos leads automatiquement envoyes a Leadrs depuis votre cms Bubble.', logo: bubbleImg, status: 'not-setup', source: '' },
        { name: 'System.io', service: 'systemio', description: 'Vos leads automatiquement envoyes a Leadrs depuis votre cms System.io.', logo: systemIoImg, status: 'not-setup', source: '' },
        { name: 'PrestaShop', service: 'prestashop', description: 'Vos leads automatiquement envoyes a Leadrs depuis votre cms PrestaShop.', logo: prestaShopImg, status: 'not-setup', source: '' },
        { name: 'Unbounce', service: 'unbounce', description: 'Vos leads automatiquement envoyes a Leadrs depuis unbounce.', logo: unbouncedImg, status: 'not-setup', source: '' },
        { name: 'Bolt', service: 'bolt', description: 'Vos leads automatiquement envoyes a Leadrs depuis votre cms Bolt.', logo: boltImg, status: 'not-setup', source: '' },
        { name: 'Landbot', service: 'landbot', description: 'Vos leads automatiquement envoyes a Leadrs depuis votre cms Landbot.', logo: landbotImg, status: 'not-setup', source: '' },
        { name: 'Google Sheet', service: 'gsheet', description: 'Vos leads automatiquement envoyes a Leadrs depuis un Google Sheet.', logo: GsheetImg, status: 'not-setup', source: '' },
    ]);

    const getOffer = () => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };
        axios
            .get(`${CONFIG.apiUrl}/offer/${params.id}`, config)
            .then((res) => {
                setOffer(res.data);
                if (!res.data.tested) {
                    setErrorMessage("Nous n'avons par encore recu le lead de test pour cette integration.");
                } else {
                    setErrorMessage(null);
                }
            })
            .catch((err) => {
                console.log('No user info found', err);
            });
    };

    const PluginCard = ({ logo, name, description, service, status, index }: {
        logo: any;
        name: string;
        service: string;
        description: string;
        status?: string;
        index: number;
    }) => {
        const nav = useNavigate();

        return (
            <div className="relative flex flex-col rounded-xl border border-leadrs-stroke bg-white p-5 transition-all hover:border-leadrs-brand hover:shadow-sm">
                {status === 'online' && (
                    <div className="absolute right-3 top-3 rounded-lg bg-leadrs-green-focus px-2 py-1 font-geist text-xs text-white">
                        Connecte
                    </div>
                )}
                {status === 'offline' && (
                    <div className="absolute right-3 top-3 rounded-lg bg-leadrs-red-focus px-2 py-1 font-geist text-xs text-white">
                        Deconnecte
                    </div>
                )}
                <div className="w-full">
                    <img
                        src={logo}
                        alt={`${name}-logo`}
                        className="h-[60px] w-[60px] rounded-lg border border-leadrs-stroke object-contain"
                    />
                    <h4 className="mt-3 font-geist text-base font-semibold text-leadrs-text">{name}</h4>
                    <p className="mt-1 font-geist text-xs text-leadrs-text-soft">{description}</p>
                </div>
                <div className="mt-4">
                    {status === 'coming-soon' && (
                        <button className="w-full cursor-not-allowed rounded-lg bg-leadrs-bg px-4 py-2 font-geist text-sm font-medium text-leadrs-text-soft">
                            Bientot disponible
                        </button>
                    )}
                    {status === 'not-setup' && (
                        <button
                            className="w-full rounded-lg bg-leadrs-brand px-4 py-2 font-geist text-sm font-medium text-white transition-opacity hover:opacity-80"
                            onClick={() => setSelectedService(service)}
                        >
                            Integrer {name}
                        </button>
                    )}
                    {status === 'online' && (
                        <button
                            className="w-full rounded-lg border border-leadrs-stroke px-4 py-2 font-geist text-sm font-medium text-leadrs-text transition-colors hover:border-leadrs-brand"
                            onClick={() => nav(`/integrate/${service}`)}
                        >
                            Gerer les parametres
                        </button>
                    )}
                </div>
            </div>
        );
    };

    const CmsChoice = () => (
        <div className="flex flex-col gap-6">
            {loading ? (
                <div className="rounded-xl border border-leadrs-stroke bg-white p-10">
                    <p className="text-center font-geist text-sm text-leadrs-text-soft">Chargement des extensions...</p>
                </div>
            ) : (
                <>
                    <div className="rounded-xl border border-leadrs-stroke bg-white p-6">
                        <h2 className="font-geist text-base font-bold text-leadrs-text">Votre CMS</h2>
                        <p className="mt-1 font-geist text-sm text-leadrs-text-soft">
                            Selectionnez votre CMS pour etre guide dans l'integration avec leadrs.
                        </p>
                    </div>
                    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 lg:grid-cols-4">
                        {services.map((service, index) => (
                            <PluginCard
                                index={index}
                                key={service.service}
                                name={service.name}
                                service={service.service}
                                description={service.description}
                                logo={service.logo}
                                status={service.status}
                            />
                        ))}
                    </div>
                </>
            )}
        </div>
    );

    const BackButton = () => (
        <button
            className="flex items-center gap-1 font-geist text-sm text-leadrs-text-soft transition-colors hover:text-leadrs-text"
            onClick={() => setSelectedService(null)}
        >
            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
            </svg>
            Retour
        </button>
    );

    const ApiUrlDisplay = ({ user, params, selectedService }: { user: any; params: any; selectedService: any }) => {
        const [copied, setCopied] = useState(false);
        const apiUrl = `https://api.leadrs.io/${user?._id}/${params.id}`;

        const handleCopy = () => {
            navigator.clipboard.writeText(apiUrl);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        };

        return (
            <div className="mt-6 w-full max-w-3xl rounded-xl border border-leadrs-stroke bg-white px-6 py-8">
                <h2 className="mb-3 text-center font-geist text-lg font-semibold text-leadrs-text">
                    URL de l'API
                </h2>

                <div className="relative mb-4 rounded-lg bg-leadrs-bg px-4 py-3">
                    <p className="break-all text-center font-mono text-sm text-leadrs-text">
                        {apiUrl}
                    </p>
                    <button
                        onClick={handleCopy}
                        className="absolute right-3 top-3 font-geist text-sm text-leadrs-text-soft transition hover:text-leadrs-text"
                        title="Copier"
                    >
                        {copied ? '✅' : '📋'}
                    </button>
                </div>

                <div className="space-y-2 text-center font-geist text-sm text-leadrs-text-soft">
                    <p>
                        Dans le champ <code className="font-semibold text-leadrs-text">Action</code> indiquez l'URL ci-dessus
                    </p>
                    <p>
                        Dans le champ <code className="font-semibold text-leadrs-text">Method</code> indiquez POST
                    </p>
                    <p>
                        Envoyez un lead de test avec <code className="font-semibold text-leadrs-text">integrate@leadrs.co</code> en email
                    </p>
                </div>

                <div className="mt-7 flex justify-center">
                    {offer?.tested ? (
                        <button
                            className="rounded-lg bg-leadrs-green-focus px-4 py-2 font-geist text-sm font-medium text-white transition-opacity hover:opacity-80"
                            onClick={() => (window.location.href = '/integrate-offers')}
                        >
                            Integration reussie !
                        </button>
                    ) : (
                        <button
                            className="rounded-lg bg-leadrs-brand px-4 py-2 font-geist text-sm font-medium text-white transition-opacity hover:opacity-80"
                            onClick={getOffer}
                        >
                            C'est fait ! Verifier l'integration
                        </button>
                    )}
                </div>

                {errorMessage && (
                    <div className="mt-3 text-center">
                        <p className="font-geist text-sm text-leadrs-red-focus">{errorMessage}</p>
                        <button
                            className="mt-1 font-geist text-sm text-leadrs-brand underline hover:opacity-80"
                            onClick={() => window.open('/my-leads', '_blank')}
                        >
                            Afficher les leads recus par leadrs.
                        </button>
                    </div>
                )}
            </div>
        );
    };

    const initUser = () => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };
        axios
            .get(`${CONFIG.apiUrl}/user/me`, config)
            .then((res: any) => {
                setUser(res.data);
                if (res.data && res.data.type !== 'seller') {
                    window.location.href = '/my-request';
                }
            })
            .catch((err: any) => {
                console.log('No user info found', err);
            });
    };

    useEffect(() => {
        initUser();
    }, []);

    return (
        <div>
            {selectedService === null ? (
                <CmsChoice />
            ) : (
                <div className="flex flex-col gap-4">
                    <BackButton />
                    <div className="flex flex-col items-center justify-center">
                        <img
                            src={services.find((s) => s.service === selectedService)?.logo}
                            alt={`${selectedService}-logo`}
                            className="h-[70px] w-[70px] rounded-lg border border-leadrs-stroke object-contain"
                        />
                        <h4 className="mt-4 font-geist text-lg font-semibold text-leadrs-text">
                            Integration de {selectedService}
                        </h4>
                        <p className="mt-2 font-geist text-xs text-leadrs-text-soft">
                            Suivez les etapes pour integrer {selectedService} a Leadrs.
                        </p>
                        <iframe
                            width="700px"
                            height="400px"
                            src={services.find((s) => s.service === selectedService)?.source}
                            title="Comment connecter son formulaire avec leadrs"
                            allow="clipboard-write"
                            className="mt-4 rounded-xl border border-leadrs-stroke"
                            sandbox="allow-popups allow-popups-to-escape-sandbox allow-scripts allow-forms allow-same-origin allow-presentation"
                        />
                        <ApiUrlDisplay user={user} params={params} selectedService={selectedService} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default IntegrateSpecificOffer;
